import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import Cookies from "js-cookie";

export const getEmployees = createAsyncThunk(
  "Employees/getEmployees",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios
        .get(`${process.env.REACT_APP_BACKEND_API}api/company/employee`, {
          headers: {
            Authorization: `Bearer ${Cookies.get("QanonToken")}`,
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          params: data && data,
        })
        .then((res) => res.data);
      return result;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);
export const getEmployees_id = createAsyncThunk(
  "Employees/getEmployees_id",
  async (id, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const data = await axios
        .get(`${process.env.REACT_APP_BACKEND_API}api/company/employee/${id}`, {
          headers: {
            Authorization: `Bearer ${Cookies.get("QanonToken")}`,
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        })
        .then((res) => res.data);
      return data;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);

export const AddEmployees = createAsyncThunk(
  "Employees/AddEmployees",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios
        .post(
          `${process.env.REACT_APP_BACKEND_API}api/company/employee`,
          data,
          {
            headers: {
              Authorization: `Bearer ${Cookies.get("QanonToken")}`,
              "Content-Type": "multipart/form-data",
              Accept: "application/json",
            },
          }
        )
        .then((res) => res.data);
      return result;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);

export const UpdateEmployees = createAsyncThunk(
  "Employees/UpdateEmployees",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios
        .post(
          `${process.env.REACT_APP_BACKEND_API}api/company/employee/${data.id}/update`,
          data.data,
          {
            headers: {
              Authorization: `Bearer ${Cookies.get("QanonToken")}`,
              "content-type": "multipart/form-data",
              Accept: "application/json",
            },
          }
        )
        .then((res) => res.data);
      return result;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);

export const CreateEmployeeRole = createAsyncThunk(
  "Employees/CreateEmployeeRole",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios
        .post(
          `${process.env.REACT_APP_BACKEND_API}api/company/add_admin`,
          data,
          {
            headers: {
              Authorization: `Bearer ${Cookies.get("QanonToken")}`,
              "content-type": "multipart/form-data",
              Accept: "application/json",
            },
          }
        )
        .then((res) => res.data);
      return result;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);
export const UpdateAdminEmployees = createAsyncThunk(
  "Employees/UpdateAdminEmployees",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios
        .post(
          `${process.env.REACT_APP_BACKEND_API}api/company/employee/${data.id}/update`,
          data,
          {
            headers: {
              Authorization: `Bearer ${Cookies.get("QanonToken")}`,
              "Content-Type": "application/json",
              Accept: "application/json",
            },
          }
        )
        .then((res) => res.data);
      return result;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);

export const UpdateDetailEmployees = createAsyncThunk(
  "Employees/UpdateDetailEmployees",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios
        .post(
          `${process.env.REACT_APP_BACKEND_API}api/company/employee/detail/create_or_update`,
          data,
          {
            headers: {
              Authorization: `Bearer ${Cookies.get("QanonToken")}`,
              "Content-Type": "application/json",
              Accept: "application/json",
            },
          }
        )
        .then((res) => res.data);
      return result;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);

export const UpdateContactInformationEmployees = createAsyncThunk(
  "Employees/UpdateContactInformationEmployees",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios
        .post(
          `${process.env.REACT_APP_BACKEND_API}api/company/employee/contact_information/create_or_update`,
          data,
          {
            headers: {
              Authorization: `Bearer ${Cookies.get("QanonToken")}`,
              "Content-Type": "application/json",
              Accept: "application/json",
            },
          }
        )
        .then((res) => res.data);
      return result;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);
export const UpdateContactEmployees = createAsyncThunk(
  "Employees/UpdateContactEmployees",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios
        .post(
          `${process.env.REACT_APP_BACKEND_API}api/company/employee/contact/create_or_update`,
          data,
          {
            headers: {
              Authorization: `Bearer ${Cookies.get("QanonToken")}`,
              "Content-Type": "application/json",
              Accept: "application/json",
            },
          }
        )
        .then((res) => res.data);
      return result;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);

export const UpdateFamilyEmployees = createAsyncThunk(
  "Employees/UpdateFamilyEmployees",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios
        .post(
          `${process.env.REACT_APP_BACKEND_API}api/company/employee/family_data/create_or_update`,
          data,
          {
            headers: {
              Authorization: `Bearer ${Cookies.get("QanonToken")}`,
              "Content-Type": "application/json",
              Accept: "application/json",
            },
          }
        )
        .then((res) => res.data);
      return result;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);

// UpdateSkillsEmployees
export const UpdateSkillsEmployees = createAsyncThunk(
  "Employees/UpdateSkillsEmployees",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios
        .post(
          `${process.env.REACT_APP_BACKEND_API}api/company/employee/skill/create_or_update`,
          data,
          {
            headers: {
              Authorization: `Bearer ${Cookies.get("QanonToken")}`,
              "content-type": "multipart/form-data",
              Accept: "application/json",
            },
          }
        )
        .then((res) => res.data);
      return result;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);

export const DeleteEmployees = createAsyncThunk(
  "Employees/DeleteEmployees",
  async (id, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const data = await axios
        .delete(
          `${process.env.REACT_APP_BACKEND_API}api/company/employee/${id}`,
          {
            headers: {
              Authorization: `Bearer ${Cookies.get("QanonToken")}`,
              "Content-Type": "application/json",
              Accept: "application/json",
            },
          }
        )
        .then((res) => res.data);
      return data;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);

export const getLawyer = createAsyncThunk(
  "Employees/getLawyer",
  async (_, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios
        .get(`${process.env.REACT_APP_BACKEND_API}api/company/employee`, {
          headers: {
            Authorization: `Bearer ${Cookies.get("QanonToken")}`,
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          params: {
            job_name: "محامي",
          },
        })
        .then((res) => res.data);
      return result;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);
export const getCounselor = createAsyncThunk(
  "Employees/getCounselor",
  async (_, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios
        .get(`${process.env.REACT_APP_BACKEND_API}api/company/employee`, {
          headers: {
            Authorization: `Bearer ${Cookies.get("QanonToken")}`,
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          params: {
            job_name: "مستشار",
          },
        })
        .then((res) => res.data);
      return result;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);
const EmployeesSlice = createSlice({
  name: "Employees",
  initialState: {
    isEmployeesLoading: false,
    error: null,
    empolyeesArray: null,
    LawyerArray: null,
    CounselorArray: null,
  },

  extraReducers: {
    [getEmployees.pending]: (state, action) => {
      state.isEmployeesLoading = true;
    },
    [getEmployees.fulfilled]: (state, action) => {
      state.empolyeesArray = action.payload.data;
      state.isEmployeesLoading = false;
    },
    [getEmployees.rejected]: (state, action) => {
      state.isEmployeesLoading = false;
    },
    // getEmployees_id
    [getEmployees_id.pending]: (state, action) => {
      state.isEmployeesLoading = true;
    },
    [getEmployees_id.fulfilled]: (state, action) => {
      state.isEmployeesLoading = false;
    },
    [getEmployees_id.rejected]: (state, action) => {
      state.isEmployeesLoading = false;
    },
    // getLawyer
    [getLawyer.pending]: (state, action) => {
      state.isEmployeesLoading = true;
    },
    [getLawyer.fulfilled]: (state, action) => {
      state.isEmployeesLoading = false;
      state.LawyerArray = action.payload.data;
    },
    [getLawyer.rejected]: (state, action) => {
      state.isEmployeesLoading = false;
    },
    // getCounselor
    [getCounselor.pending]: (state, action) => {
      state.isEmployeesLoading = true;
    },
    [getCounselor.fulfilled]: (state, action) => {
      state.isEmployeesLoading = false;
      state.CounselorArray = action.payload.data;
    },
    [getCounselor.rejected]: (state, action) => {
      state.isEmployeesLoading = false;
    },
    [AddEmployees.pending]: (state, action) => {
      state.isEmployeesLoading = true;
    },
    [AddEmployees.fulfilled]: (state, action) => {
      // state.empolyeesArray = action.payload.data;
      state.isEmployeesLoading = false;
    },
    [AddEmployees.rejected]: (state, action) => {
      state.isEmployeesLoading = false;
    },
    // UpdateCategories
    [UpdateEmployees.pending]: (state, action) => {
      state.isEmployeesLoading = true;
    },
    [UpdateEmployees.fulfilled]: (state, action) => {
      state.isEmployeesLoading = false;
    },
    [UpdateEmployees.rejected]: (state, action) => {
      state.isEmployeesLoading = false;
    },
    // CreateEmployeeRole
    [CreateEmployeeRole.pending]: (state, action) => {
      state.isEmployeesLoading = true;
    },
    [CreateEmployeeRole.fulfilled]: (state, action) => {
      state.isEmployeesLoading = false;
    },
    [CreateEmployeeRole.rejected]: (state, action) => {
      state.isEmployeesLoading = false;
    },
    [DeleteEmployees.pending]: (state, action) => {
      state.isEmployeesLoading = true;
    },
    [DeleteEmployees.fulfilled]: (state, action) => {
      state.empolyeesArray = state.empolyeesArray.filter(
        (ele) => ele.id !== action.meta.arg
      );
      state.isEmployeesLoading = false;
    },
    [DeleteEmployees.rejected]: (state, action) => {
      state.isEmployeesLoading = false;
    },
    // UpdateAdminEmployees
    [UpdateAdminEmployees.pending]: (state, action) => {
      state.isEmployeesLoading = true;
    },
    [UpdateAdminEmployees.fulfilled]: (state, action) => {
      state.isEmployeesLoading = false;
    },
    [UpdateAdminEmployees.rejected]: (state, action) => {
      state.isEmployeesLoading = false;
    },
    // UpdateDetailEmployees
    [UpdateDetailEmployees.pending]: (state, action) => {
      state.isEmployeesLoading = true;
    },
    [UpdateDetailEmployees.fulfilled]: (state, action) => {
      state.isEmployeesLoading = false;
    },
    [UpdateDetailEmployees.rejected]: (state, action) => {
      state.isEmployeesLoading = false;
    },
    // UpdateContactInformationEmployees
    [UpdateContactInformationEmployees.pending]: (state, action) => {
      state.isEmployeesLoading = true;
    },
    [UpdateContactInformationEmployees.fulfilled]: (state, action) => {
      state.isEmployeesLoading = false;
    },
    [UpdateContactInformationEmployees.rejected]: (state, action) => {
      state.isEmployeesLoading = false;
    },
    // UpdateContactEmployees
    [UpdateContactEmployees.pending]: (state, action) => {
      state.isEmployeesLoading = true;
    },
    [UpdateContactEmployees.fulfilled]: (state, action) => {
      state.isEmployeesLoading = false;
    },
    [UpdateContactEmployees.rejected]: (state, action) => {
      state.isEmployeesLoading = false;
    },
    // UpdateFamilyEmployees
    [UpdateFamilyEmployees.pending]: (state, action) => {
      state.isEmployeesLoading = true;
    },
    [UpdateFamilyEmployees.fulfilled]: (state, action) => {
      state.isEmployeesLoading = false;
    },
    [UpdateFamilyEmployees.rejected]: (state, action) => {
      state.isEmployeesLoading = false;
    },
    // UpdateSkillsEmployees
    [UpdateSkillsEmployees.pending]: (state, action) => {
      state.isEmployeesLoading = true;
    },
    [UpdateSkillsEmployees.fulfilled]: (state, action) => {
      state.isEmployeesLoading = false;
    },
    [UpdateSkillsEmployees.rejected]: (state, action) => {
      state.isEmployeesLoading = false;
    },
  },
});

export default EmployeesSlice.reducer;
